import { useState, forwardRef } from "react";
import AsyncSelect from "react-select/async";
import pin from "../assets/pin.svg";
import pinWhite from "../assets/pinWhite.svg";

const AddressInput = forwardRef(
  ({ handleSubmit, isTransparent, isForm, value, onChange, buttonText = "CONTINUE" }, ref) => {
    const [inputValue, setInputValue] = useState("");

    // This function calls the Domain API with the current input and returns options for react-select.
    const loadOptions = async (input) => {
      if (!input) return [];
      try {
        const response = await fetch(
          `https://agent.adrianwilliam.com.au/scripts/domain/suggest.php?terms=${encodeURIComponent(
            input
          )}`
        );
        const suggestions = await response.json();
        // Map each suggestion into an option with a label and value.
        return suggestions.map((suggestion) => ({
          label: suggestion.address,
          value: suggestion.id,
        }));
      } catch (error) {
        console.error("Error fetching address suggestions", error);
        return [];
      }
    };

    // Update local state on input change.
    const handleInputChange = (newValue) => {
      setInputValue(newValue);
      return newValue;
    };

    return (
      <div
        className={
          isForm
            ? ""
            : `flex ${
                isTransparent
                  ? "bg-transparentWhite flex-row justify-between border border-white"
                  : "flex-col bg-white gap-1 p-1.5 lg:p-0.5"
              }`
        }
      >
        <div
          className={
            isForm ? "flex flex-col" : "flex flex-row items-center flex-1"
          }
        >
          {!isForm && (
            <img
              src={isTransparent ? pinWhite : pin}
              alt="pin"
              className={
                isTransparent ? "w-7 h-7 m-4" : "w-5 h-5 ml-2 mr-3 lg:my-3.5"
              }
            />
          )}
          <div
            className={`flex-1 h-full flex flex-col justify-center lg:text-xl ${
              !isForm && "border-x border-white"
            }`}
          >
            <AsyncSelect
              cacheOptions
              loadOptions={loadOptions}
              defaultOptions
              value={value}
              onChange={onChange}
              onInputChange={handleInputChange}
              placeholder="Enter address..."
              styles={{
                placeholder: (provided) => ({
                  ...provided,
                  color: isTransparent ? "white" : "#101820",
                  fontFamily: "Maison Neue, sans-serif",
                  fontWeight: 400,
                  opacity: 0.3,
                  backgroundColor: "transparent",
                  margin: 0,
                }),
                container: (provided) => ({
                  ...provided,
                  width: "100%",
                  backgroundColor: "transparent",
                }),
                input: (provided) =>
                  isForm
                    ? {
                        ...provided,
                        padding: 0,
                        fontFamily: "Maison Neue, sans-serif",
                        fontWeight: 400,
                        margin: 0,
                        backgroundColor: "transparent",
                      }
                    : {
                        ...provided,
                        width: "100%",
                        color: isTransparent ? "white" : "#101820",
                        fontFamily: "Maison Neue, sans-serif",
                        fontWeight: 400,
                        backgroundColor: "transparent",
                      },
                valueContainer: (provided) =>
                  isForm
                    ? {
                        ...provided,
                        padding: "16px 20px",
                        backgroundColor: "rgba(0, 0, 0, 0.05)",
                      }
                    : {
                        ...provided,
                      },
                singleValue: (provided) => ({
                  ...provided,
                  color: isTransparent ? "white" : "#101820",
                  fontFamily: "Maison Neue, sans-serif",
                  fontWeight: 400,
                  backgroundColor: "transparent",
                }),
                control: (provided) => ({
                  ...provided,
                  width: "100%",
                  color: isTransparent ? "white" : "#101820",
                  backgroundColor: "transparent",
                  border: 0,
                  boxShadow: "none",
                }),
                indicatorsContainer: (provided) => ({
                  ...provided,
                  display: "none",
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                  backgroundColor: "white",
                  color: "#101820",
                }),
              }}
              ref={ref}
            />
          </div>
        </div>
        {!isForm && (
          <button
            onClick={handleSubmit}
            className="font-maison-mono font-normal bg-primary text-white py-2.5 lg:py-4 lg:px-16 lg:text-xl"
          >
            {buttonText}
          </button>
        )}
      </div>
    );
  }
);

export default AddressInput;